import type { PartnerComponents } from 'config/types';
import { lazyWithPreload } from 'utils/bundle';
import { getPartnerSpecificComponent } from 'utils/helpers';

const CareemStepper = lazyWithPreload(() => import('packages/careem/newOrder'));
const InstaShopStepper = lazyWithPreload(() => import('packages/instashop/newOrder'));
const DefaultStepper = lazyWithPreload(() => import('packages/app/newOrder'));

const stepperComponents: PartnerComponents<{}> = {
  INSTASHOP: InstaShopStepper,
  CAREEM: CareemStepper,
  Default: DefaultStepper,
};

export const NewOrderStepper = getPartnerSpecificComponent<{}>(stepperComponents);
